import React, {useEffect, useState} from 'react';
import white_arrow from "../../image/arrow/white_arrow.png";
import Util from "../../../public/utils";
import txt from "../../image/file/txt.png";
import ppt from "../../image/file/ppt.png";
import word from "../../image/file/word.png";
import excel from "../../image/file/excel.png";
import pdf from "../../image/file/pdf.png";
import image from "../../image/file/image.jpg";
import zip from "../../image/file/zip.png";
import unknownFile from "../../image/messageList/unknownFile.png";
import wxappLink from "../../image/messageList/wxappLink.png";
import red_arrow from "../../image/arrow/red_arrow.jpg";
import redBag from "../../image/messageList/redBag.jpg";
import {Divider, Image} from "antd";
import msgRecord from "../../image/messageList/msgRecord.png";
import CloudApi from "../../../cloud/cloud_api";
import videoHao from "../../image/messageList/videoHao.png";
import RightClick from "../rightclick/rightclick";
import {Item} from "react-contexify";


export const ImText = React.memo((props) => {
    const {avatar, name, sendTime, content} = props.data
    const {keyword} = props
    return (
        <div className={'im-msg-record-max'}>
            <img src={avatar} className={'im-record-avatar'}/>
            <div className={'record-right'}>
                <div className={'record-rightTop'}>
                    <span>{name}</span>
                    <span>{formateTime(sendTime)}</span>
                </div>
                <div className={'record-detail-text'}>
                    <div
                        dangerouslySetInnerHTML={{__html: Util.textHightLight(content.content || '', keyword)}}/>
                </div>
            </div>
        </div>
    );
})

export const ImVideo = React.memo((props) => {
    const {avatar, name, sendTime, content, wxid} = props.data
    const [fileSrc, setFileSrc] = useState('')
    useEffect(() => {
        let bodyData = {
            msgId: content.msg_unique_identifier,
            wxid: wxid
        }
        CloudApi.getChatFileUrl(bodyData, data => {
            if (data.url) {
                setFileSrc(data.url)
            } else {
                setFileSrc('noUrl')
            }
        }, error => {
        })
    }, [])
    return (
        <div className={'im-msg-record-max'}>
            <img src={avatar} className={'im-record-avatar'}/>
            <div className={'record-right'}>
                <div className={'record-rightTop'}>
                    <span>{name}</span>
                    <span>{formateTime(sendTime)}</span>
                </div>
                <div className={'record-detail-video'}>
                    {
                        fileSrc ?
                            <video controls className={'record-video'}>
                                <source
                                    src={fileSrc}
                                    type="video/mp4"/>
                                您的浏览器不支持 视频播放。
                            </video> : ''
                    }
                </div>
            </div>
        </div>
    );
})

export const ImImage = React.memo((props) => {
    const {avatar, name, sendTime, content, wxid} = props.data
    const [fileSrc, setFileSrc] = useState('')
    useEffect(() => {
        if (props.data.type == 29) return
        let bodyData = {
            msgId: content.msg_unique_identifier,
            wxid: wxid
        }
        CloudApi.getChatFileUrl(bodyData, data => {
            if (data.url) {
                setFileSrc(data.url)
            } else {
                setFileSrc('noUrl')
            }
        }, error => {
        })
    }, [])
    return (
        <div className={'im-msg-record-max'}>
            <img src={avatar} className={'im-record-avatar'}/>
            <div className={'record-right'}>
                <div className={'record-rightTop'}>
                    <span>{name}</span>
                    <span>{formateTime(sendTime)}</span>
                </div>
                <div className={'record-detail-img'}>
                    <Image
                        preview={{src: content.gif_url || (fileSrc + '?x-oss-process=image/auto-orient,1/quality,q_80/format,webp')}}
                        src={content.gif_url || fileSrc}
                        className={'record-img'}/>
                </div>
            </div>
        </div>
    );
})

export const ImFile = React.memo((props) => {
    const {avatar, name, sendTime, content, wxid} = props.data
    const [fileSrc, setFileSrc] = useState('')
    useEffect(() => {
        let bodyData = {
            msgId: content.msg_unique_identifier,
            wxid: wxid
        }
        CloudApi.getChatFileUrl(bodyData, data => {
            if (data.url) {
                setFileSrc(data.url)
            } else {
                setFileSrc('noUrl')
            }
        }, error => {
        })
    }, [])
    return (
        <div className={'im-msg-record-max'}>
            <img src={avatar} className={'im-record-avatar'}/>
            <div className={'record-right'}>
                <div className={'record-rightTop'}>
                    <span>{name}</span>
                    <span>{formateTime(sendTime)}</span>
                </div>
                <div className={'record-detail-img'}>
                    <RightClick
                        menuId={"rightClick" + content.msg_unique_identifier}
                        item={
                            <Item onClick={() => {
                                getBlob(fileSrc).then(res => saveAs(res, content.file_name))
                            }}>下载</Item>
                        }
                    >
                        <div className={'record-file'}>
                            <img src={white_arrow}
                                 className={'not_self_arrow'}/>
                            <img src={fileImg(content.file_name)}/>
                            <div
                                className={'unknownFile-right'}>
                                <span>{content.file_name || '未知文件'}</span>
                                <div>{Util.fileSizeToString(content.file_size)}</div>
                            </div>
                        </div>
                    </RightClick>
                </div>
            </div>
        </div>
    );
})

export const ImCard = React.memo((props) => {
    const {avatar, name, sendTime, content} = props.data
    return (
        <div className={'im-msg-record-max'}>
            <img src={avatar} className={'im-record-avatar'}/>
            <div className={'record-right'}>
                <div className={'record-rightTop'}>
                    <span>{name}</span>
                    <span>{formateTime(sendTime)}</span>
                </div>
                <div className={'record-detail-card'}>
                    <div className={'record-card'}>
                        <img src={white_arrow} className={'not_self_arrow'}/>
                        <div className={'record-card-header'}>
                            <img src={content.headimg}/>
                            <div>{content.nick}</div>
                        </div>
                        <div className={'record-card-line'}></div>
                        <div className={'record-card-wxcard'}>{'个人名片'}</div>
                    </div>
                </div>
            </div>
        </div>
    );
})

export const ImWxApp = React.memo((props) => {
    const {avatar, name, sendTime, content} = props.data
    return (
        <div className={'im-msg-record-max'}>
            <img src={avatar} className={'im-record-avatar'}/>
            <div className={'record-right'}>
                <div className={'record-rightTop'}>
                    <span>{name}</span>
                    <span>{formateTime(sendTime)}</span>
                </div>
                <div className={'record-detail-card'}>
                    <div className={'record-wxapp'}>
                        <img src={white_arrow} className={'not_self_arrow'}/>
                        <div className={'record-wxapp-header'}>
                            <img src={content.headimg || content.thumburl}/>
                            <div>{content.title}</div>
                        </div>
                        <span className={'record-wxapp-desc'}>{content.des}</span>
                        {/*<img src={content.coverImgUrl} className={'record-wxapp-big-img'}/>*/}
                        <div
                            className={'wx-app-bg'}
                            style={{backgroundImage: `url(${content.coverImgUrl})`}}>
                        </div>
                        <div className={'record-card-line'}></div>
                        <div className={'record-wxapp-bottom'}>
                            <img src={wxappLink}/>
                            <div className={'record-card-wxcard'}>{'小程序'}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
})

export const ImRed = React.memo((props) => {
    const {avatar, name, sendTime, content} = props.data
    return (
        <div className={'im-msg-record-max'}>
            <img src={avatar} className={'im-record-avatar'}/>
            <div className={'record-right'}>
                <div className={'record-rightTop'}>
                    <span>{name}</span>
                    <span>{formateTime(sendTime)}</span>
                </div>
                <div className={'record-detail-card'}>
                    <div className={'record-redBag-max'}>
                        <img src={red_arrow} className={'not_self_arrow'}/>
                        <div className={'record-red-topMax'}>
                            <img src={redBag}/>
                            <div>
                                <div className={'record-red-name'}>{content.des}</div>
                                <div className={'record-red-money'}>￥{Util.centTransformOut(content.money)}</div>
                            </div>
                        </div>
                        <Divider className={'record-red-divider'}/>
                        <span className={'record-red-bottom'}>{'红包'}</span>
                    </div>
                </div>
            </div>
        </div>
    );
})

export const ImRecord = React.memo((props) => {
    const {avatar, name, sendTime} = props.data
    return (
        <div className={'im-msg-record-max'}>
            <img src={avatar} className={'im-record-avatar'}/>
            <div className={'record-right'}>
                <div className={'record-rightTop'}>
                    <span>{name}</span>
                    <span>{formateTime(sendTime)}</span>
                </div>
                <div className={'record-detail-card'}>
                    <div className={'im2-record-max'}>
                        <img src={white_arrow} className={'not_self_arrow'}/>
                        <div className={'im2-record-top'}>
                            <img src={msgRecord}/>
                            <span>{'聊天记录'}</span>
                        </div>
                        <Divider className={'im2-record-divider'}/>
                        <span className={'im2-record-bottom'}>{'请进入手机版企业微信查看'}</span>
                    </div>
                </div>
            </div>
        </div>
    );
})

export const ImAudio = React.memo((props) => {
    const {avatar, name, sendTime, content, wxid} = props.data
    return (
        <div className={'im-msg-record-max'}>
            <img src={avatar} className={'im-record-avatar'}/>
            <div className={'record-right'}>
                <div className={'record-rightTop'}>
                    <span>{name}</span>
                    <span>{formateTime(sendTime)}</span>
                </div>
                <div className={'record-detail-card'}>
                    [语音]
                </div>
            </div>
        </div>
    );
})

export const ImVideoHao = React.memo((props) => {
    const {avatar, name, sendTime, content} = props.data
    return (
        <div className={'im-msg-record-max'}>
            <img src={avatar} className={'im-record-avatar'}/>
            <div className={'record-right'}>
                <div className={'record-rightTop'}>
                    <span>{name}</span>
                    <span>{formateTime(sendTime)}</span>
                </div>
                <div className={'record-detail-card'}>
                    <div className={'record-videoHao-max'}>
                        <div className={'record-video-bg'}
                             style={{backgroundImage: `url(${content.thumb_url})`}}>
                        </div>
                        <div
                            className={'record-videoHao-mid'}>
                            <img
                                src={content.head_img_url}/>
                            <span>{content.username}</span>
                        </div>
                        <div
                            className={'record-videoHao-desc'}>{content.channel_name}</div>
                        <div
                            className={'record-videoHao-divider'}>
                            <Divider/>
                        </div>
                        <div
                            className={'record-videoHao-bottom'}>
                            <img
                                src={videoHao}/>
                            <span>{'视频号'}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
})

const fileImg = (fileName) => {
    // console.log('9898', fileName)
    if (!fileName) {
        return unknownFile
    }
    if (fileName.indexOf('txt') != -1) {
        return txt
    } else if (fileName.indexOf('ppt') != -1) {
        return ppt
    } else if (fileName.indexOf('doc') != -1) {
        return word
    } else if (fileName.indexOf('xlsx') != -1 || fileName.indexOf('xls') != -1 || fileName.indexOf('csv') != -1) {
        return excel
    } else if (fileName.indexOf('pdf') != -1) {
        return pdf
    } else if (fileName.indexOf('jpg') != -1 || fileName.indexOf('jpeg') != -1 || fileName.indexOf('png') != -1 || fileName.indexOf('gif') != -1) {
        return image
    } else if (fileName.indexOf('zip') != -1 || fileName.indexOf('rar') != -1 || fileName.indexOf('png') != -1 || fileName.indexOf('7z') != -1 || fileName.indexOf(' gzip') != -1 || fileName.indexOf(' tar.gz') != -1) {
        return zip
    } else {
        return unknownFile
    }
}

const formateTime = time => {
    let str = '';
    //是今天，显示小时分
    try {
        if (new Date().getDate() == new Date(time).getDate()) {
            str = new Date(time).format('hh:mm');
        } else {
            let year = new Date(time).getFullYear().toString().substring(2);
            let month = new Date(time).getMonth() + 1;
            let day = new Date(time).getDate();
            str = year + '/' + month + '/' + day + ' ' + new Date(time).format('hh:mm');
        }
    } catch (e) {

    }
    return str;
}

const getBlob = (url) => { // url:是文件在oss上的地址
    return new Promise(resolve => {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "blob";// 请求类型是blob类型
        xhr.crossOrigin = "*"; // 解决跨域问题
        xhr.onload = () => {
            if (xhr.status === 200) {
                resolve(xhr.response);
            }
        };
        xhr.send();
    });
};

const saveAs = (blob, filename) => {
    const link = document.createElement("a");
    const body = document.querySelector("body");
    const myBlob = new Blob([blob])
    link.href = window.URL.createObjectURL(myBlob);
    link.download = filename; //修改文件名
    link.style.display = "none";
    body.appendChild(link);
    link.click();
    body.removeChild(link);
};
